var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M12.586 75.414c.39.391.902.586 1.414.586a1.99 1.99 0 001.414-.586L44 46.828l28.586 28.586c.39.391.902.586 1.414.586a2 2 0 001.414-3.414L46.828 44l28.586-28.586a2 2 0 10-2.828-2.828L44 41.172 15.414 12.586a2 2 0 10-2.828 2.828L41.172 44 12.586 72.586a2 2 0 000 2.828"
  })));
}

export default __webpack_public_path__ + "fd2e15e395f2f5bf0dd2843fe079b537.svg";
export { SvgIconClose as ReactComponent };